<template>
  <div class="text-center mb-5">
    <i class="far fa-meh" style="font-size: 54px; color: #bdbdbd;"></i> <br />
    {{ $t('reports.dontHaveData') }}
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
};
</script>



// WEBPACK FOOTER //
// src/components/molecules/empty-state/index.vue